import { useNavigate, useSearchParams } from "react-router-dom";

import { ClientContextProvider } from "features/admin/contexts/ClientContext";
import ClientForm from "features/admin/clients/ClientForm";
import ClientsTable from "features/admin/clients/ClientsTable";
import { DrawerContextProvider } from "shared/contexts/DrawerContext";
import { DropdownMultiSelectContextProvider } from "shared/contexts/DropdownMultiSelectContext";
import Modal from "shared/components/feedback/modals/MasterModal";
import PageWrapper from "app/components/PageWrapper";
import { ServerSidePaginationContextProvider } from "shared/contexts/ServerSidePaginationContext";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const action = searchParams.get("action");
    const id = searchParams.get("id");

    const onClose = () => {
        navigate(".", { replace: true });
    };

    if (action === "add") {
        return (
            <Modal
                title="Add Client"
                stickyAction={true}
                onRequestClose={onClose}
            >
                <ClientForm key="new" onClose={onClose} />
            </Modal>
        );
    }

    const parsedId = Number.parseInt(id);

    if (action === "edit" && !Number.isNaN(parsedId)) {
        return (
            <Modal
                title="Edit Client"
                stickyAction={true}
                onRequestClose={onClose}
            >
                <ClientForm
                    clientIdToEdit={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};

const Clients = () => {
    return (
        <DrawerContextProvider>
            <PageWrapper
                title="Clients"
                menuOptions={[{ children: "Admin", to: "/admin" }]}
            >
                <ServerSidePaginationContextProvider>
                    <DropdownMultiSelectContextProvider>
                        <ClientContextProvider>
                            <FormPresenter />
                            <ClientsTable />
                        </ClientContextProvider>
                    </DropdownMultiSelectContextProvider>
                </ServerSidePaginationContextProvider>
            </PageWrapper>
        </DrawerContextProvider>
    );
};

export default Clients;
